var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useMemo, useState } from "react";
import { useDebounce } from "use-debounce";
import { useGenres } from "frontend/src/domain/genres";
export var useSearchTrackForm = function () {
    var _a = __read(useState(""), 2), search = _a[0], setSearch = _a[1];
    var genres = useGenres().genres;
    var _b = __read(useDebounce(search, 500), 1), trackTitle = _b[0];
    var _c = __read(useState({}), 2), checkedGenres = _c[0], setCheckedGenres = _c[1];
    var changeSearch = function (evt) { var _a; return setSearch((_a = evt.target.value) !== null && _a !== void 0 ? _a : ""); };
    var genresWithCheckedStatus = genres === null || genres === void 0 ? void 0 : genres.map(function (genre) { return (__assign(__assign({}, genre), { isChecked: genre.id in checkedGenres })); });
    var toggleById = function (id) {
        var _a;
        if (checkedGenres[id]) {
            setCheckedGenres(function (_a) {
                var _b = id, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                return rest;
            });
        }
        else {
            setCheckedGenres(__assign((_a = {}, _a[id] = true, _a), checkedGenres));
        }
    };
    var checkedGenresIds = useMemo(function () { return Object.keys(checkedGenres).map(function (id) { return parseInt(id); }); }, [checkedGenres]);
    return {
        search: {
            value: search,
            onChange: changeSearch,
            debouncedValue: trackTitle,
        },
        genres: {
            entries: genresWithCheckedStatus,
            toggleById: toggleById,
            checkedIds: checkedGenresIds,
        },
    };
};
